import DefaultCell from "application/components/DefaultCell";
import { taskManagementSystem } from "globals/configuration/taskManagementSystem";

const operationURLS = {
  list: "/task/listAllView",
  pdfDownload: "/blasterReport/generateAndDownloadPdf",
  csvDownload: "/task/downloadViewCSV",
};

const Attributes = {
  formSize: "md",
    enableAddButton: false,
    enableUpdateTableRecords: true,
    enableAdvanceSearch: true,
    enableDownloadButton: true,
    enableDownloadPdf: false,
    enableRefresh: true,

  modes: taskManagementSystem.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const getColumns = () => {
  return [
    {
      Header: "Ticket No",
      accessor: "tskid",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Task Source",
      accessor: "tasksource",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Task Subject",
      accessor: "tasksname",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Task Type",
      accessor: "tasktype",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Task priority",
      accessor: "taskpriority",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Customer Name",
      accessor: "customername",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Contact No",
      accessor: "contactno",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Assigned User",
      accessor: "assigneduser",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Reviewer",
      accessor: "reviewer",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Current Status",
      accessor: "currentstats",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Assigned On",
      accessor: "assignedon",
      displayInList: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "SLA (In Hrs)",
      accessor: "sla",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "SLA Date",
      accessor: "slaepoch",
      displayInList: true,
      allowFilter: false,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Task Completed Date",
      accessor: "taskcompletedon",
      displayInList: true,
      allowFilter: false,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "SLA Status",
      accessor: "slastatus",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, operationURLS,Attributes };
